import styled, { css } from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { darken } from 'polished'

export const StyleText = styled.p`
  font-family: ${(props) => (props.red ? 'MatterBold' : 'MatterRegular')} !important;
  font-size: ${(props) => (props.blue ? '13px' : '16px')};
  margin: ${(props) => (props.red ? '0px 4px 0px 4px' : props.blue ? '0px' : '5px 3px 0px 0px')};
  color: ${(props) =>
    props.red
      ? props.theme.coral
      : props.blue
      ? props.theme.blueDark
      : props.oos
      ? '#9199A0'
      : props.theme.grayDark};
  text-decoration: ${(props) => (props.isDiscounted ? 'line-through' : 'none')};
`
export const SubLabel = styled.h3`
  font-size: 22px;
  line-height: 32px;
  margin: ${(props) => (props.oos ? '24px 0px 0px' : '24px 0px 12px')};
  color: ${(props) => (props.red ? props.theme.coral : props.theme.grayDark)};
  b {
    font-family: 'P22MackinacProBold' !important;
  }
`

export const CalMaxIcon = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
`
export const StyleOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* justify-content: flex-start; */
`
export const SelectionOption = styled.div`
  cursor: pointer;
  flex: 0 0 auto;
  white-space: normal;
  word-wrap: break-word;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  margin-right: 8px;
  padding: ${(props) => (props.selected ? `16px` : '19px')};
  width: 206px;
  border: ${(props) =>
    props.selected
      ? `3px solid ${props.theme.skylightBlue}`
      : props.oos
      ? '3px solid #9199A0'
      : 'none'};
  border-radius: 24px;
  position: relative;
  background-color: ${(props) => (props.selected ? '#FAFAFA' : '#F6F5ED')};
  opacity: ${(props) => (props.oos ? '50%' : 'transparent')};
  text-align: ${(props) => (props.center ? 'center' : 'left')};
`
export const StyleDescription = styled.p`
  color: #4f4e4e;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  margin: 5px 0px 8px;
`
export const LimitedAvailable = styled.p`
  font-family: 'MatterRegular' !important;
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${(props) => (props.red ? props.theme.coral : props.theme.grayDark)};
  font-size: 13px;
`
export const Badge = styled.p`
  border-radius: 18px;
  background: #0f627e;
  color: white;
  padding: 4px 20px 4px;
  font-size: 19px;
  line-height: none;
  font-family: 'MatterRegular' !important;
  text-align: center;
  margin: 0px 0px 0px 16px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
    margin: 0px 16px;
    padding: 4px 12px 4px;
  }
  @media (max-width: 390px) {
    font-size: 12px;
    margin: 0px 12px;
    padding: 4px 8px 4px;
  }
  @media (max-width: 365px) {
    font-size: 10px;
    margin: 0px 8px;
    padding: 4px 10px;
  }
`
export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`
export const PickPriceContainer = styled.div`
  margin-top: ${(props) => (props.topMargin ? '24px' : '0px')};
`

export const GiftModeImage = styled.div`
  width: 160px;
  position: absolute;
  left: 20px;
  top: 20px;
  @media (max-width: 1500px) {
    width: 130px;
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 160px;
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 120px;
    left: 10px;
    top: 10px;
  }
  @media (max-width: ${breakpoints.s}px) {
    width: 80px;
    left: 8px;
    top: 8px;
  }
  @media (max-width: 400px) {
    width: 70px;
  }
`

// Temp styles for holiday badge
// export const GiftModeImage = styled.div`
//   width: 175px;
//   position: absolute;
//   left: 80px;
//   top: 20px;
//   @media (max-width: 1500px) {
//     width: 21%;
//     left: 40px;
//   }
//   @media (max-width: ${breakpoints.s}px) {
//     width: 100px;
//     left: 10px;
//     top: 0px;
//   }
//   @media (max-width: 400px) {
//     width: 80px;
//     left: 8px;
//   }
// `
export const CalFeatureRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  @media (max-width: ${breakpoints.s}px) {
    flex-direction: column;
  }
`
export const CalFeature = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: center;
`
export const CalFeatureHeading = styled.h3`
  margin: 0px;
  font-size: 16px;
  color: ${(props) => props.theme.appearance};
`
export const CalFeatureText = styled.p`
  margin: 0px !important;
  padding: 5px;
  font-size: 12px;
  color: ${(props) => props.theme.appearance};
`
export const IconContainer = styled.div`
  margin: auto;
  margin-top: 0px;
  margin-bottom: 10px;
  height: 100px;
  width: 100px;
  @media (max-width: ${breakpoints.s}px) {
    margin-bottom: 10px;
  }
`

export const PlusPlanIncludes = styled.p`
  text-align: center;
  margin: 10px 0px !important;
  color: ${(props) => props.theme.appearance};
  text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};
`
export const ProductSelectionBoxWrapper = styled.div`
  position: relative;
`
const productSelectionBoxCss = css`
  padding: 16px 22px;
  border-radius: 24px;
  margin-bottom: 8px;
`

export const ProductSelectionBox = styled.section`
  ${productSelectionBoxCss}
  border: 3px solid ${(props) => props.theme.skylightBlue};
  background-color: ${(props) => props.theme.blueLightest};
  p {
    margin-left: 40px;
  }
  li {
    font-family: 'MatterRegular';
    font-weight: normal !important;
    b {
      font-family: 'MatterBold';
    }
  }
  button {
    width: 100%;
    margin-bottom: 10px;
  }
  @media (max-width: ${breakpoints.s}px) {
    padding-bottom: 10px;
  }
`

export const ClickableProductSelectionBox = styled.section`
  ${productSelectionBoxCss}
  background-color: #F6F5ED;
  cursor: pointer;
  @media (max-width: ${breakpoints.s}px) {
    padding-bottom: 30px;
  }
`
export const ProductSelectionHeaderRow = styled.section`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${breakpoints.s}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`
export const ProductSelectionPricePointCss = css`
  font-size: 22px;
  font-family: 'MatterRegular';
  font-weight: 300;
  line-height: 26px;
  letter-spacing: 0.1px;
  margin: 0;
  strike {
    font-size: 16px;
    color: ${(props) => props.theme.grayLight};
    padding-right: 3px;
  }
  @media (max-width: 1250px) {
    font-size: 20px;
    strike {
      font-size: 14px;
    }
  }
  @media (max-width: ${breakpoints.l}px) {
    font-size: 22px;
    strike {
      font-size: 16px;
    }
  }
`
export const ProductSelectionPricePoint = styled.section`
  ${ProductSelectionPricePointCss};
  color: ${(props) => props.theme.coral};
  display: flex;
`

export const ClickableProductSelectionPricePoint = styled.section`
  ${ProductSelectionPricePointCss}
  color: ${(props) => props.theme.coral};
  display: flex;
  align-items: center;
`
export const ProductSelectionHeader = styled.section`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: ${breakpoints.s}px) {
    align-items: flex-start;
  }
`
export const RadioIconContainer = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 16px;
  align-self: center;
  @media (max-width: ${breakpoints.s}px) {
    margin-top: 24px;
  }
`
export const MostPopular = styled.span`
  background-color: ${(props) => props.theme.skylightBlue};
  color: white;
  border-radius: 28px;
  padding: 5px 10px;
  z-index: 10;
  align-self: center;
  margin-left: 24px;
`
export const PriceAndExplainerContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 15px;
  text-align: right;
  @media (max-width: 1730px) {
    padding-top: 0px;
  }
  @media (max-width: 600px) {
    padding-top: 0px;
  }
  @media (max-width: ${breakpoints.s}px) {
    align-items: flex-start;
    margin-left: 40px;
  }
`
export const OneTimePurchase = styled.section`
  margin: 0;
  font-size: 12px;
  line-height: 1;
  max-width: 170px;
  color: ${(props) => props.theme.appearance};
  @media (max-width: 1730px) {
    text-align: right;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 12px;
    max-width: 100%;
    text-align: left;
  }
  @media (max-width: 460px) {
    max-width: 200px;
  }
`
const SaveInfoCss = css`
  font-family: 'P22MackinacProBold';
  font-size: 22px;
  margin-top: 24px;
  color: ${(props) => props.theme.appearance};
  @media (max-width: ${breakpoints.s}px) {
    margin-bottom: 0px;
  }
  @media (max-width: 1250px) {
    font-size: 20px;
  }
  @media (max-width: ${breakpoints.l}px) {
    font-size: 22px;
  }
`
export const PlanHeading = styled.h3`
  ${SaveInfoCss};
`

export const SaveInfo = styled.h3`
  ${SaveInfoCss};
  @media (max-width: 1510px) {
    width: ${(props) => (props.calendar ? '300px' : '100%')};
  }
  @media (max-width: 1400px) {
    width: ${(props) => (props.calendar ? '250px' : '150px')};
  }
  @media (max-width: 1250px) {
    width: ${(props) => (props.calendar ? '210px' : '150px')};
  }
  @media (max-width: 1100px) {
    width: ${(props) => (props.calendar ? '175px' : '150px')};
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 300px;
  }
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
  }
`

export const Disclosure = styled.p`
  font-family: 'MatterRegular' !important;
  color: ${(props) => darken(0.1, props.theme.blueDark)};
  a {
    color: ${(props) => darken(0.1, props.theme.blueDark)};
  }
`
export const ColorContainer = styled.div`
  display: flex;
  align-items: center;
`
export const ComingSoonDisclosure = styled.p`
  position: absolute;
  bottom: -48px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #b4482d;
  font-size: 14px;
  text-align: center;
  visibility: ${(props) => (props.visable ? 'visible' : 'hidden')};
  @media (max-width: ${breakpoints.s}px) {
    font-size: 12px;
    bottom: -38px;
  }
  @media (max-width: 380px) {
    font-size: 10px;
    bottom: -32px;
  }
`
export const ThumbnailVideo = styled.div`
  width: ${(props) => (props.isFrame ? '100px' : '60px')};
  @media (max-width: 1360px) {
    width: ${(props) => (props.isFrame ? '100px' : '40px')};
  }
  @media (max-width: 1160px) {
    width: ${(props) => (props.isFrame ? '100px' : '30px')};
  }
  @media (max-width: ${breakpoints.l}px) {
    width: ${(props) => (props.isFrame ? '100px' : '60px')};
  }
  @media (max-width: 750px) {
    width: ${(props) => (props.isFrame ? '100px' : '40px')};
  }
  @media (max-width: 550px) {
    width: ${(props) => (props.isFrame ? '70px' : '40px')};
  }
  @media (max-width: 400px) {
    width: ${(props) => (props.isFrame ? '60px' : '27px')};
  }
  @media (max-width: 350px) {
    width: ${(props) => (props.isFrame ? '60px' : '20px')};
  }
`
export const CalendarVideoThumbnail = styled.img`
  max-width: 100%;
`
export const VideoContainer = styled.div`
  position: relative;
  overflow: hidden;
  max-width: 100%;
  height: auto;
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
  @media (max-width: ${breakpoints.l}px) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
`

export const BogoContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.reverse ? 'row-reverse' : 'row')};
  gap: 16px;
  @media (max-width: 1850px) {
    flex-direction: ${(props) => (props.reverse ? 'column-reverse' : 'column')};
    gap: 0px;
  }
`
export const PriceContainer = styled.div`
  display: flex;
  gap: 4px;
`

export const BubbleContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Strikethough = styled.span`
  text-decoration: line-through;
  margin-right: 8px;
  @media (max-width: 360px) {
    margin-right: 5px;
  }
`

export const Price = styled.span`
  color: ${({ theme, color }) => theme[color]};
`
export const ComingSoon = styled.p`
  position: absolute;
  top: 20px;
  margin: 0px;
  font-size: 28px;
  line-height: 1;
  text-align: center;
  color: rgba(75, 75, 75, 1);
`

export const Card = styled.div`
  align-items: center;
  padding: 16px;
  border-radius: 10px;
  cursor: pointer;
  border: 3px solid transparent;
  margin-top: 16px;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  ${(props) =>
    props.selected
      ? css`
          border-color: props.theme.blueDark;
          background-color: props.theme.blueLightest;
        `
      : css`
          border-color: #ccc;
        `}
`

export const Checkbox = styled.input`
  width: 20px;
  height: 20px;
  accent-color: ${(props) => props.theme.blueDark};
  margin-right: 8px;
`

export const Content = styled.div`
  display: flex;
  position: relative;
`

export const Title = styled.p`
  font-size: 18px;
  margin: 0;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
  }
`

export const Description = styled.p`
  font-size: 14px;
  width: 260px;
  line-height: 1.2;
  margin: 0px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 12px;
    width: 200px;
  }
`

export const PriceRow = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  font-size: 12px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 11px;
    bottom: -2px;
  }
`

export const WasPrice = styled.span`
  color: #999;
  margin-right: 8px;
`

export const NowPrice = styled.span`
  color: ${(props) => props.theme.coral};
  font-family: 'MatterBold';
`

export const SaleBadge = styled.span`
  position: absolute;
  top: 0px;
  right: 0px;
  background-color: ${(props) => props.theme.coral};
  color: white;
  font-family: 'MatterBold';
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 26px;
`

export const Subheader = styled.h2`
  font-size: 20px;
  line-height: 32px;
  margin: 16px 0px;
  color: ${(props) => props.theme.appearance};
  @media (max-width: ${breakpoints.s}px) {
    font-size: 20px;
    line-height: 32px;
  }
`

export const SizeBarContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 8px;
  background-color: #f3f2e9;
  border-radius: 100px;
  > * {
    flex: 1;
  }
`

export const SizeOption = styled.p`
  font-family: 'MatterBold' !important;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  margin: 0px;
  padding: ${(props) => (props.selected ? `6px` : '8px')};
  border-radius: 100px;
  color: ${(props) => (props.selected ? props.theme.skylightBlue : props.theme.appearance)};
  border: ${(props) => (props.selected ? `3px solid ${props.theme.skylightBlue}` : 'none')};
  background: ${(props) => (props.selected ? props.theme.blueLightest : 'none')};
`

export const DropDownContainer = styled.div`
  border-radius: 0px !important;
  display: flex;
  align-items: stretch;
  margin-top: ${(props) => (props.margin ? '-30px' : '0px')};
  @media (max-width: ${breakpoints.s}px) {
    p {
      font-size: 15px;
    }
  }
  @media (max-width: 400px) {
    p {
      font-size: 14px;
    }
  }
`

export const DropDownContainerOptions = styled(DropDownContainer)`
  flex-direction: column;
  box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 20%);
`

export const DropDownLabel = styled.div`
  padding: 0px;
  margin: 0px;
  padding: 5px 15px;
  border: 1px solid black;
  width: calc(100% - 40px);
  cursor: pointer;
  display: flex;
  justify-content: ${(props) => (props.bfcm ? 'space-between' : 'space-between')};
  gap: ${(props) => (props.bfcm ? '30px' : '0px')};
  align-items: center;
  p {
    margin: 0px;
  }
  @media (max-width: ${breakpoints.s}px) {
    p {
      font-size: 15px;
    }
  }
  @media (max-width: 400px) {
    padding: ${(props) => (props.bfcm && props.isCalMax ? '5px 0px 5px 5px' : '5px 8px')};
    p {
      font-size: 14px;
    }
  }
  @media (max-width: 350px) {
    p {
      font-size: 13px;
    }
  }
`
export const DropDownLabelOption = styled(DropDownLabel)`
  width: 100%;
  border-top: none;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  cursor: pointer;
`
export const DropDownImageContainer = styled.div`
  width: 40px;
  border-top: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  cursor: pointer;
`
export const DropDownIconContainer = styled.div`
  width: 16px;
  height: 10px;
  margin: auto;
  padding-top: 15px;
`
export const ColorSelectionContainer = styled.div`
  width: 110px;
  border-radius: 24px;
  padding: 16px 8px 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  background-color: ${(props) => (props.isSelected ? '#FAFAFA' : '#F6F5ED')};
  border: ${(props) =>
    props.isSelected ? `3px solid ${props.theme.skylightBlue}` : '3px solid #F6F5ED'};
  @media (max-width: ${breakpoints.s}px) {
    padding: 12px 6px 10px;
    width: ${(props) => (props.is15 ? '22%' : '30%')};
  }
  @media (max-width: 380px) {
    margin-right: 6px;
  }
  position: relative;
`

export const Bubble = styled.p`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  line-height: 1.7;
  font-size: 11px !important;
  background-color: ${(props) =>
    props.bfcm
      ? props.theme.sunshine
      : props.blue
      ? props.theme.blueDark
      : props.lavender
      ? props.theme.lavenderMedium
      : props.theme.grayDark};
  font-family: 'MatterRegular' !important;
  color: ${(props) =>
    props.bfcm ? props.theme.grayDark : props.lavender ? props.theme.grayDark : 'white'};
  border-radius: 100px;
  padding: 2px 8px;
  margin-right: ${(props) => (props.bfcm && props.isCalMax ? '4px' : '10px')} !important;
  text-align: center;
  justify-content: center;
  @media (max-width: 360px) {
    font-size: 10px !important;
    padding: 2px 0px;
    margin-right: ${(props) => (props.bfcm && props.isCalMax ? '0px' : '5px')} !important;
  }
`
export const WirecutterBadge = styled.div`
  width: 160px;
  position: absolute;
  right: 24px;
  bottom: 24px;
  @media (max-width: 1500px) {
    width: 120px;
  }
  @media (max-width: ${breakpoints.xl}px) {
    width: 100px;
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 160px;
    margin-right: 5%;
    right: 0px;
    bottom: 7%;
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 100px;
  }
  @media (max-width: 420px) {
    width: 70px;
    margin-right: 5%;
  }
`
export const ProductImageContainer = styled.div`
  position: relative;
`
